<div class="container-fluid">
  <app-header titleText="Inventory Report" i18n-titleText>
    <div button class="float-right">
      <div *ngIf="!isRequesting">
        <button type="button" class="btn btn-bidit-navigate mr-1" (click)="showParameters()" i18n>Update Filters</button>
        <button *ngIf="report" type="button" class="btn btn-bidit-navigate" (click)="renderReport()" i18n>Export</button>
      </div>
      <app-spinner [isRunning]="isRequesting"></app-spinner>
    </div>
  </app-header>

  <div *ngIf="report == null" class="container">
    <div class="row">
      <h5 class="col-sm-12" i18n>Please provide report criteria</h5>
    </div>
  </div>
  <div *ngIf="report">
    <div class="row header-text">
      <div class="col-md-4">
        <app-dealer-logo></app-dealer-logo>
      </div>
      <div class="col-md-6 filter-zone">
        <p>
          <ng-template [ngIf]="parameters.itemSearch"><span i18n>Item Search:</span> {{parameters.itemSearch}}<br /></ng-template>
          <ng-template [ngIf]="selectedItemTypes.length > 0"><span i18n>Item Type:</span> {{selectedItemTypeString}}<br /></ng-template>
          <ng-template [ngIf]="this.selectedRValue"><span i18n>R-Value:</span> {{this.selectedRValue}}<br /></ng-template>
          <ng-template [ngIf]="this.selectedStatus"><span i18n>Status:</span> {{this.selectedStatus}}<br /></ng-template>
          <ng-template [ngIf]="this.selectedVendor"><span i18n>Vendor:</span> {{this.selectedVendor}}<br /></ng-template>
          <ng-template [ngIf]="this.selectedWarehouse"><span i18n>Warehouse:</span> {{this.selectedWarehouse}}<br /></ng-template>
        </p>
      </div>
    </div>

    <div class="content">
        <table class="table table-bidit">
          <thead>
            <tr>
              <th i18n>Item Type</th>
              <th i18n>Item Name</th>
              <th i18n>R-Value</th>
              <th i18n>Vendor</th>
              <th i18n>Warehouse</th>
              <th i18n>Available Qty</th>
              <th i18n>Allocated Qty</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of report">
              <td>
                {{item.itemType_Desc}}
              </td>
              <td>{{item.item_Desc}}</td>
              <td>{{item.rValue_Desc}}</td>
              <td>{{item.vendor_BusinessName}}</td>
              <td>{{item.warehouse_Name}}</td>
              <td>{{item.available_Qty}}</td>
              <td>{{item.allocated_Qty}}</td>
            </tr>
          </tbody>
        </table>
    </div>
  </div>
</div>
